export default "__VITE_ASSET__BIJqLKcO__"